import { message } from 'antd';
import React, { useEffect } from 'react';
import ApiService from '../services/ApiService';

const useAuth = () => {
  const [loading, setLoading] = React.useState(false);
  const [status, setStatus] = React.useState('email'); // possible values are email, code
  const [email, setEmail] = React.useState();

  useEffect(() => {
    return () => {
      setEmail(undefined);
      setStatus('email');
      setLoading(false);
    };
  },[]);

  const handleResetPassword = async (email) => {
    try {
      setEmail(email);
      setLoading(true);
      if (email) {
        await ApiService.forgetPassword(email);
        setStatus('code');
        message.success('Verification Code Sent');
      } else {
        message.error('Please enter email');
      }
    } catch (error) {
      console.log('error : ', error);
      message.error(error?.message || 'Error');
      setEmail(undefined);
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPasswordSubmit = async (data) => {
    try {
      setLoading(true);
      await ApiService.forgetPasswordSubmit({
        email,
        ...data,
      });
      message.success('Password Reset Successfully');
    } catch (error) {
      console.log('error : ', error);
      message.error(error.message || 'Error');
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    status,
    loading,
    handleResetPassword,
    handleForgotPasswordSubmit,
  };
};

export default useAuth;
